'use client';

import { ArrowForward } from '@mui/icons-material';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

import Button from '@/components/bases/Button';

export const ExploreCtaSection = () => {
  const theme = useTheme();
  const router = useRouter();

  const openAdminPage = () => {
    window.open(process.env.NEXT_PUBLIC_ADMIN_URL, '_blank');
  };

  return (
    <Stack
      width={'100%'}
      alignItems={'center'}
      justifyContent={'center'}
      padding={{ xs: '12px', md: '24px' }}
      sx={{ position: 'relative' }}>
      <Stack
        alignItems={'center'}
        justifyContent={'center'}
        gap={3}
        sx={{
          width: '100%',
          height: { xs: 320, md: 400 },
          borderRadius: '24px',
          overflow: 'hidden',
          position: 'relative',
          background: theme.palette.whiteAlpha['03'],
        }}>
        {/* Background image with dark overlay */}
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.35)), url(/images/build-collection-img.jpg)`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        />

        {/* Content */}
        <Stack
          zIndex={1}
          alignItems={'center'}
          justifyContent={'center'}
          gap={3}
          padding={{ xs: '32px', md: '40px 80px' }}>
          <Typography
            textAlign={'center'}
            color={theme.palette.text.primary}
            fontWeight={600}
            fontSize={{ xs: '20px', md: '40px' }}
            lineHeight={'1.2em'}>
            Ready to launch your own <span style={{ color: theme.palette.brand.primary }}>NFT </span> collection?
          </Typography>
          <Typography
            sx={{ marginTop: { xs: '-20px', md: '0px' } }}
            textAlign={'center'}
            color={theme.palette.text.primary}
            fontWeight={600}
            fontSize={{ xs: '20px', md: '40px' }}
            lineHeight={'1.2em'}>
            Get started today.
          </Typography>

          <Button variant={'primary'} size={'large'} onClick={openAdminPage} sx={{ gap: 1.5 }}>
            <Stack direction={'row'} alignItems={'center'} gap={1.5}>
              <Typography fontSize={{ xs: '14px', md: '16px' }} fontWeight={600} lineHeight={'1.5em'}>
                BUILD YOUR COLLECTION
              </Typography>
              <ArrowForward />
            </Stack>
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ExploreCtaSection;
